import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { CoreCommonModule } from "../../../@core/common.module";
import { OnboardingStoreModule } from 'app/main/pages/customer-onboard-flow/store/onboarding/onboarding.module';

import { canActivate } from "./can-activate";
import { ConfirmInvitationComponent } from "./components/confirm-invitation/confirm-invitation.component";
import { conformInvitationFeatureKey } from "./store/confirm-invitation.config";
import { ConformInvitationEffects } from "./store/confirm-invitation.effects";
import { conformInvitationReducers } from './store/confirm-invitation.reducers';
import { TranslocoDirective } from '@jsverse/transloco';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'app/main/shared/shared/shared.module';
import { CoreDirectivesModule } from '@core/directives/directives';
import { OnboardingUserProfileComponent } from 'app/main/pages/shared/onboardingUserProfileComponent/onboarding-user-profile.component';
import { OnboardingTellUsAboutYouComponent } from 'app/main/pages/shared/onboardingTellUsAboutYouComponent/onboarding-tell-us-about-you.component';
import { OnboardingHowPlanToUseComponent } from 'app/main/pages/shared/onboardingHowPlanToUseComponent/onboarding-how-plan-to-use.component';

const routes: Routes = [
    {
        path: '',
        component: ConfirmInvitationComponent,
        data: { animation: 'auth' },
        canActivate: [canActivate]
    }
]

@NgModule({
    declarations: [
        ConfirmInvitationComponent
    ],
    imports: [
        CommonModule,
        NgbModule,
        FormsModule,
        ReactiveFormsModule,
        CoreCommonModule,
        TranslocoDirective,
        StoreModule.forFeature(conformInvitationFeatureKey, conformInvitationReducers),
        EffectsModule.forFeature(ConformInvitationEffects),
        RouterModule, // Explicitly add RouterModule
        RouterModule.forChild(routes),
        NgSelectModule,
        SharedModule,
        CoreDirectivesModule,
        OnboardingStoreModule,
        OnboardingUserProfileComponent,
        OnboardingTellUsAboutYouComponent,
        OnboardingHowPlanToUseComponent
    ],
    exports: [
        ConfirmInvitationComponent
    ]
})
export class ConfirmInvitationModule {
}
